var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mb-4 mx-2",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-form', {
    model: {
      value: _vm.localValid,
      callback: function callback($$v) {
        _vm.localValid = $$v;
      },
      expression: "localValid"
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.title'),
      "readonly": !_vm.isEditing,
      "outlined": ""
    },
    model: {
      value: _vm.local.title,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "title", $$v);
      },
      expression: "local.title"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('template-editor', {
    key: 'template-editor' + !_vm.isEditing,
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "outlined": true,
      "label": _vm.$t('objects.contract.description'),
      "readOnly": !_vm.isEditing
    },
    model: {
      value: _vm.local.description,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "description", $$v);
      },
      expression: "local.description"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.startDate'),
      "type": "date",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    model: {
      value: _vm.local.startDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "startDateFormable", $$v);
      },
      expression: "local.startDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.endDate'),
      "type": "date",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    model: {
      value: _vm.local.endDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "endDateFormable", $$v);
      },
      expression: "local.endDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('refs-select-form', {
    attrs: {
      "label": _vm.$t('objects.contract.clientIds'),
      "partnerId": _vm.local.partnerId,
      "disabled": !_vm.isEditing,
      "categories": [_vm.ResourceEnum.COMPANY, _vm.ResourceEnum.PERSON],
      "small": true
    },
    model: {
      value: _vm.local.clientIds,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "clientIds", $$v);
      },
      expression: "local.clientIds"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('refs-select-form', {
    attrs: {
      "label": _vm.$t('objects.contract.providerIds'),
      "partnerId": _vm.local.partnerId,
      "disabled": !_vm.isEditing,
      "categories": [_vm.ResourceEnum.COMPANY, _vm.ResourceEnum.PERSON],
      "small": true
    },
    model: {
      value: _vm.local.providerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "providerIds", $$v);
      },
      expression: "local.providerIds"
    }
  })], 1)], 1)], 1), _vm.local.type === _vm.contracTypeEnum.INSURANCE && _vm.local.details ? _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "disabled": !_vm.isEditing,
      "customField": {
        label: _vm.$t('objects.contract.hasGapCoverage')
      }
    },
    model: {
      value: _vm.local.details.hasGapCoverage,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "hasGapCoverage", $$v);
      },
      expression: "local.details.hasGapCoverage"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.fullComprehensiveDeductible'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.fullComprehensiveDeductibleFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "fullComprehensiveDeductibleFormable", _vm._n($$v));
      },
      expression: "local.details.fullComprehensiveDeductibleFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.partialCoverageDeductible'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.partialCoverageDeductibleFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "partialCoverageDeductibleFormable", _vm._n($$v));
      },
      expression: "local.details.partialCoverageDeductibleFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "disabled": !_vm.isEditing,
      "customField": {
        label: _vm.$t('objects.contract.hasRoadsideAssistance')
      }
    },
    model: {
      value: _vm.local.details.hasRoadsideAssistance,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "hasRoadsideAssistance", $$v);
      },
      expression: "local.details.hasRoadsideAssistance"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.maxTowingAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.maxTowingAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "maxTowingAmountFormable", _vm._n($$v));
      },
      expression: "local.details.maxTowingAmountFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.maxRoadsideCoverageAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.maxRoadsideCoverageAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "maxRoadsideCoverageAmountFormable", _vm._n($$v));
      },
      expression: "local.details.maxRoadsideCoverageAmountFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.rentalCarDailyRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.rentalCarDailyRateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "rentalCarDailyRateFormable", _vm._n($$v));
      },
      expression: "local.details.rentalCarDailyRateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.rentalCarMaxDays'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.rentalCarMaxDaysFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "rentalCarMaxDaysFormable", _vm._n($$v));
      },
      expression: "local.details.rentalCarMaxDaysFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.maxBreakdownAssistanceAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.maxBreakdownAssistanceAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "maxBreakdownAssistanceAmountFormable", _vm._n($$v));
      },
      expression: "local.details.maxBreakdownAssistanceAmountFormable"
    }
  })], 1)], 1)], 1) : _vm.local.type === _vm.contracTypeEnum.WORKSHOP && _vm.local.details ? _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.paintHourlyBillingRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.hourlyBillingRatePaintFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "hourlyBillingRatePaintFormable", _vm._n($$v));
      },
      expression: "local.details.hourlyBillingRatePaintFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.paintMaterialPercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.local.details.paintMaterialPercentageFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "paintMaterialPercentageFormable", _vm._n($$v));
      },
      expression: "local.details.paintMaterialPercentageFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.mechanicalHourlyBillingRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.local.details.hourlyBillingRateMechanicalFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "hourlyBillingRateMechanicalFormable", _vm._n($$v));
      },
      expression: "local.details.hourlyBillingRateMechanicalFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.sparePartsDiscountPercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.local.details.sparePartsDiscountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "sparePartsDiscountFormable", _vm._n($$v));
      },
      expression: "local.details.sparePartsDiscountFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.sparePartsSurchargePercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.local.details.sparePartsSurchargeFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local.details, "sparePartsSurchargeFormable", _vm._n($$v));
      },
      expression: "local.details.sparePartsSurchargeFormable"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('v-card-actions', [!_vm.isEditing ? _c('v-btn', {
    attrs: {
      "color": "info",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.isEditing = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("edit")) + " ")]) : [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "info",
      "elevation": "0",
      "disabled": !_vm.localValid || _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "info",
      "elevation": "0"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")])]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }